export default () => {
  return (chatbot) => {
    window.resetSession = () => {
      chatbot.actions.resetSession();
    };
  };
};
